import { cn } from '@/lib/utils'
import type { ContextSnapshot } from '@/types/contextObservability'
import { extractLlmPayload } from '@/lib/contextTransformers'
import { JsonTreeView } from './JsonTreeView'

export interface RawJsonViewProps {
  snapshot: ContextSnapshot
  className?: string
}

export function RawJsonView({ snapshot, className }: RawJsonViewProps) {
  const payload = extractLlmPayload(snapshot)

  return (
    <div className={cn(className)}>
      <JsonTreeView data={payload} />
    </div>
  )
}
